<template>
  <div class="page-content conmon-top" style="background-color: #ffffff;">
    <h1 class="weltitle">欢迎使用云商系统</h1>
    <img src="../../assets/images/welcomeys.png" alt="" style="max-height: 60%;">
  </div>
</template>
<script>
import { } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
    }
  },
  methods: {
  },
  created() {
  },
  components: {
  }
}
</script>

<style scoped>
  .weltitle{
    padding-top: 100px;
    color: #666666;
    font-size: 40px;
    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    user-select: none;
  }
</style>
